(() => {
  const configNode = document.getElementById('gm-wishlist-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent), KEY = 'gm_wishlist';
  const base = config.root.replace(/\/?$/, '/'), cache = new Map();
  let generation = 0, timer, memory = [], persistent = true;
  function clean(value) { return Array.isArray(value) ? [...new Set(value.filter(handle => typeof handle === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/.test(handle)))].slice(0,100) : []; }
  function read() { if (!persistent) return memory.slice(); try { memory = clean(JSON.parse(localStorage.getItem(KEY) || '[]')); } catch { persistent = false; } return memory.slice(); }
  function notify(text) { const status = document.querySelector('[data-wishlist-status]'); if (!status) return; status.textContent = text; status.hidden = false; clearTimeout(timer); timer = setTimeout(() => status.hidden = true,5000); }
  function save(handles) {
    memory = clean(handles);
    try { localStorage.setItem(KEY,JSON.stringify(memory)); persistent = true; } catch { persistent = false; }
    refresh(); renderPage();
  }
  function refresh() {
    const saved = read();
    document.querySelectorAll('[data-wishlist-handle]').forEach(button => {
      const active = saved.includes(button.dataset.wishlistHandle);
      button.classList.toggle('is-active',active); button.setAttribute('aria-pressed',String(active));
      button.setAttribute('aria-label',`${active ? 'Remove' : 'Add'} ${button.dataset.productTitle || 'product'} ${active ? 'from' : 'to'} wishlist`);
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(node => { node.textContent = saved.length; node.hidden = saved.length === 0; });
  }
  async function productCard(handle) {
    if (cache.has(handle)) return cache.get(handle).cloneNode(true);
    const controller = new AbortController(), timeout = setTimeout(() => controller.abort(),12000);
    try {
      const response = await fetch(`${base}products/${encodeURIComponent(handle)}?section_id=gm-wishlist-card`,{signal:controller.signal});
      if (!response.ok) throw Error('Product unavailable');
      const card = new DOMParser().parseFromString(await response.text(),'text/html').querySelector('[data-saved-handle]');
      if (!card || card.dataset.savedHandle !== handle) throw Error('Product unavailable');
      cache.set(handle,card); return card.cloneNode(true);
    } finally { clearTimeout(timeout); }
  }
  function unavailable(handle) {
    const card = document.createElement('article'); card.className = 'gm-saved-product gm-saved-product--unavailable'; card.dataset.savedHandle = handle;
    const title = document.createElement('h2'); title.textContent = handle.replace(/-/g,' ');
    const text = document.createElement('p'); text.textContent = 'This product could not be loaded. Try again later or remove it.';
    const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'button'; remove.dataset.wishlistRemove = handle; remove.textContent = 'Remove';
    card.append(title,text,remove); return card;
  }
  async function renderPage() {
    const page = document.querySelector('[data-wishlist-page]'), grid = page?.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    const request = ++generation, handles = read(), loading = page.querySelector('[data-wishlist-loading]');
    page.querySelector('[data-wishlist-clear]').hidden = handles.length === 0;
    page.querySelector('[data-wishlist-empty]').hidden = handles.length > 0;
    loading.hidden = handles.length === 0; loading.textContent = 'Loading your saved products…';
    grid.setAttribute('aria-busy',String(handles.length > 0));
    const cards = new Array(handles.length); let next = 0;
    await Promise.all(Array.from({length:Math.min(4,handles.length)},async () => {
      while (next < handles.length && request === generation) {
        const index = next++, handle = handles[index];
        try { cards[index] = await productCard(handle); } catch { cards[index] = unavailable(handle); }
      }
    }));
    if (request !== generation || !page.isConnected) return;
    grid.replaceChildren(...cards); grid.removeAttribute('aria-busy'); loading.hidden = false;
    loading.textContent = handles.length ? `${handles.length} saved ${handles.length === 1 ? 'product' : 'products'}` : '';
    if (!handles.length) loading.hidden = true;
  }
  document.addEventListener('click',event => {
    const button = event.target.closest('[data-wishlist-handle]');
    if (button) {
      event.preventDefault(); event.stopPropagation();
      const handle = button.dataset.wishlistHandle, saved = read(), active = saved.includes(handle);
      if (!active && saved.length >= 100) { notify('Your wishlist holds up to 100 products. Remove one to save another.'); return; }
      save(active ? saved.filter(item => item !== handle) : [handle,...saved]);
      notify(persistent ? active ? 'Removed from wishlist' : 'Saved to wishlist' : 'Browser storage is unavailable. Saved for this visit only.');
      return;
    }
    const remove = event.target.closest('[data-wishlist-remove]');
    if (remove) { event.preventDefault(); save(read().filter(handle => handle !== remove.dataset.wishlistRemove)); notify('Removed from wishlist'); }
    if (event.target.closest('[data-wishlist-clear]')) { save([]); notify('Wishlist cleared'); }
  },true);
  window.addEventListener('storage',event => { if (event.key === KEY || event.key === null) { persistent = true; refresh(); renderPage(); } });
  document.addEventListener('shopify:section:load',() => { refresh(); renderPage(); });
  // Dynamic collection/recommendation cards are rendered by the theme after page load.
  new MutationObserver(records => { if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('[data-wishlist-handle]') || node.querySelector?.('[data-wishlist-handle]'))))) refresh(); }).observe(document.body,{childList:true,subtree:true});
  refresh(); renderPage();
})();
